import { ComponentProps } from 'react';
import Modal from 'antd/es/modal';
import clsx from 'clsx';

interface OpModalProps extends ComponentProps<typeof Modal> {
  testId?: string;
}

export const OpModal = ({
  children,
  className,
  centered = true,
  destroyOnClose = true,
  testId,
  ...modalProps
}: OpModalProps) => (
  <Modal
    className={clsx('op-modal', className)}
    centered={centered}
    data-testid={testId}
    destroyOnClose={destroyOnClose}
    {...modalProps}
  >
    {children}
  </Modal>
);
